import CommonContactForm from "./common_contact_form";
import Footer from "./Footer";
import Header from "./Header";
import React from "react";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import { useLocation } from "react-router-dom";

const ConsultingPartner = () => {
  const location = useLocation(); // Get the current location (path)
  const meta = metaConfig.consultingpartner;

  return (
    <div>
      <SEO {...meta} />

      <div class="container-fluid position-relative p-0">
        <div class="w-100 me-3 top_head">
          <div class="top_head align-items-center"></div>
        </div>
        <Header />
      </div>

      <div class="container-fluid Finance_consulting bg-breadcrumb">
        <div class="container text-center py-5" style={{ maxWidth: "900px" }}>
          <ol
            class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          ></ol>
          <h4
            class="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Driving Innovation Together
          </h4>
        </div>
      </div>
      <div
        class="modal fade"
        id="searchModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content rounded-0">
            <div class="col-lg-12 m-auto modal-header justify-content-lg-end">
              <button
                type="button"
                class="btn-close justify-content-lg-end text-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="col-lg-9 m-auto modal-header align-items-center text-center">
              <h4
                class="modal-title mb-0 m-auto text-white"
                id="exampleModalLabel"
              >
                Search by keyword
              </h4>
            </div>
            <div class="modal-body align-items-center">
              <div class="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  class="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span
                  id="search-icon-1"
                  class="input-group-text btn border p-3"
                >
                  <i class="fa fa-search text-white"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid innercontain ktig_services_page finance_details_1 overflow-hidden pt-5">
        <div class="container">
          <div class="row col-xl-10 pb-0 m-auto g-5">
            <div
              class="text-center mt-0 mx-auto wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <h1 class="display-3 text-capitalize text-white">
                Consulting Partner
              </h1>
            </div>

            <div
              className="page_details_inner wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <p className="text-white text-left">
                Business consultants are vital to KTIG’s success, providing
                expert guidance and strategic support to help us navigate
                complex challenges and achieve our objectives. These partners
                bring specialized knowledge, industry insights, and innovative
                solutions that complement KTIG’s capabilities. By working
                together, we create a powerful ecosystem that drives growth,
                fosters innovation, and delivers exceptional value to our
                clients.
              </p>
              <p className="text-white text-left">
                Our business consultants play a key role in identifying
                opportunities, streamlining operations, and implementing
                strategies that enable us to stay ahead in a competitive market.
                Their expertise spans diverse industries and domains, making
                them invaluable in helping KTIG address evolving client needs
                and deliver tailored solutions. With their support, we can
                refine our approaches, optimize resource utilization, and
                achieve sustainable growth.
              </p>
              <p className="text-white text-left">
                KTIG values partnerships rooted in collaboration, trust, and
                shared success. We carefully select business consultants who
                align with our mission, values, and vision for the future. By
                leveraging their expertise, we can enhance our services, empower
                businesses, and create meaningful impacts.
              </p>
              <p className="text-white text-left">
                Together with our business consultants, KTIG continues to push
                boundaries, deliver transformative results, and strengthen its
                position as a trusted leader in innovation and technology.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid overflow-hidden pb-5 p-0">
        <CommonContactForm />
      </div>

      <Footer />

      <button
        className="btn btn-secondary btn-lg-square rounded-circle back-to-top"
        onClick={() => window.scrollTo(0, 0)}
      >
        <i className="fa fa-arrow-up"></i>
      </button>
    </div>
  );
};

export default ConsultingPartner;
